import React from 'react';
import PropTypes from 'prop-types';
import AddToCartButton from '../../ui_add-to-cart-button/component';
import WishlistToggle from '../../ui_wishlist_toggle/component';

import './styles.scss';

const FloatingCTA = (props) => {
  const { shouldFloat, product, store } = props;
  const { sku } = product;

  return (
    <div className="pdp-floatingCTA">
      <div className={`productDetailButtons floating ${shouldFloat ? 'triggered' : ''}`}>
        <div>
          <WishlistToggle
            withoutContent={true}
            sku={sku}
            product={product}
            buttonType="fullSize"
            store={store}
          />
        </div>
        <AddToCartButton
          smallIcon={true}
          shouldFloat={true}
          product={product}
          store={store}
          dataTestId="button-addToCartFloating"
          showQuantity={false}
          showOrderlineReference={false}
        />
      </div>
    </div>
  );
};

FloatingCTA.propTypes = {
  shouldFloat: PropTypes.bool,
  product: PropTypes.object,
  store: PropTypes.object,
  prices: PropTypes.object,
};

export default FloatingCTA;
